import { dataUserMobile } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserMobile = /*#__PURE__*/createIcon(dataUserMobile)
export default IconUserMobile
